/*
function get(name){
   if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
      return decodeURIComponent(name[1]);
}

*/
window.$ = jQuery;
jQuery( document ).ready( function( $ ) {
//   alert('ok');

/*

function WaitForFunction()
{
    if (!$.isFunction(TweenMax)) {
       setTimeout( WaitForFunction, 100);
       return;
    }
    Function_Loaded();
}

*/

//jQuery(window).on('load',function( $ ) {

	var refreshLinkToolbar = function() {
	//log("checking for link between "+window.panel1_ID+" and "+window.panel3_ID);

		if ( window.panelLoading.panel1 == true || window.panelLoading.panel3 == true ) {
			console.log( 'refreshLinkToolbar: panel is still loading' );
			//alert("panel is still loading");
			return;
		}

		log( 'refreshLinkToolbar: checking for link between ' + getCookie( 'ps_panel1' ) + ' and ' + getCookie( 'ps_panel3' ) );

		$( '#linkStatus' ).html( "<div class='spinner'></div>" );
		$( '#linkStatus' ).unbind( 'click' );

		//Make sure all the side links show an image
		$( 'a.penci-image-holder.penci-lazy.small-fix-size' ).each( function( index ) {
			console.log( index + ': ' + $( this ).text() );
			if ( $( this ).data( 'src' ) ) {
				$( this ).css( 'background-image', 'url(' + $( this ).data( 'src' ) + ')' );
			}
		} );

		$.post( {
			type: 'post',
			timeout: 20000,
			url: ajax_object.ajax_url,
			//dataType: "json",
			data: { action: 'ps_check_for_link', 1: window.panel1_ID, 2: window.panel3_ID },
			//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
			error: function( textStatus, textStatus2 ) {
				log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
			},
			success: function( response ) {
			//log('refreshLinkToolbar: Drawer Got this from the server: ');
			//log(response );
			//jQuery( document ).data('html_content_'+post_id,response);
			//$('.drawer'+drawer+' .content .1').html(response);
			//return response;

			//configureDrawerLinks();

				if ( response.indexOf( 'not found' ) >= 0 ) {
					window.link_ID = '';
					window.hasLink = false;
					//log("nothing to do - no link found");
					//$('#linkStatus').html("+");

					$( '.panel2 .content .comments' ).html( '' );
					unfocusLink();

					$( '#linkStatus' ).unbind( 'click' );
					$( '#linkStatus' ).click( function() {
						//log("clicked");
						addLink();
					} );
				} else {
					window.link_ID = response;
					window.hasLink = true;

					//log("Link ID is: "+response);
					$( '#linkStatus' ).html( '...' );
					getLink_comments();
					$( '#linkStatus' ).unbind( 'click' );
					$( '#linkStatus' ).click( function() {
						focusLink();
					} );
				}
	  },

		} );

	//getCookie("ps_drawer2")
	};//END refreshLinkToolbar
	/*np++*/

	/*
==================================================================
						   GET LINK COMMENTS
==================================================================
*/

	var getLink_comments = function() {
		if ( window.panelLoading.panel1 == true || window.panelLoading.panel3 == true ) {
			console.log( 'getLink_comments: panel is still loading' );
			//alert("panel is still loading");
			return;
		}

		log( 'getLink_comments: getting link comments for link ' + window.link_ID );

		$( '#linkStatus' ).html( "<div class='spinner'></div>" );
		$( '#linkStatus' ).unbind( 'click' );

		$.post( {
			type: 'post',
			timeout: 20000,
			url: ajax_object.ajax_url,
			//dataType: "json",
			data: { action: 'ps_get_link_comments', id: window.link_ID },
			//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
			error: function( textStatus, textStatus2 ) {
				log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
			},
			success: function( response ) {
			//log('Drawer Got this from the server: ');
			//log(response );
			//jQuery( document ).data('html_content_'+post_id,response);
			//$('.drawer'+drawer+' .content .1').html(response);
			//return response;

			//configureDrawerLinks();

				$( '.panel2 .content .comments' ).html( response );

				if ( jQuery( '#linkCommentForm' ).length ) {
					jQuery( '#linkCommentForm' )[ 0 ].encoding = 'multipart/form-data';
					$( '.panel2 .content .comments' ).find( '.sce-edit-button' ).simplecommentediting();
				} else {
					console.log( 'comment form not found, might not be logged in' );
				}

				var currentButtonConent = $( '#linkStatus' ).html();

				if ( response.indexOf( 'not found' ) >= 0 ) {
					log( 'nothing to do' );
					$( '#linkStatus' ).html( '+' );
					$( '#linkStatus' ).unbind( 'click' );
					$( '#linkStatus' ).click( function() {
						addLink();
					} );

					if ( ! window.focusLinkStatus ) {

					} else {
						mode2();
						mode2();
						mode2();
					}
				} else {
				//log("Link ID is: "+response);
					log( window.focusLinkStatus );
					if ( ! window.focusLinkStatus ) {
						$( '#linkStatus' ).html( '...' );
						$( '#linkStatus' ).unbind( 'click' );
						$( '#linkStatus' ).click( function() {
							focusLink();
						} );
					} else {
						$( '#linkStatus' ).html( 'Close' );
						focusLink();
					}

					$( '#linkCommentForm' ).attr( 'action', '' );
					$( '#linkCommentForm * .submit' ).click( function( e ) {
						e.preventDefault();
						//window.loadPageByURL(1,this.href);
						//focusPanel1();
						addLink_comment();
						//log("clicked");
	  } );

					//$('#linkCommentForm').append('<input type="hidden" name="post_id" value="'+window.link_ID+'">');
				}

				//setupvid_button('#linkCommentForm button:first-of-type');
				if ( screen.width < 500 ) {
					var videowidth = screen.width;
				} else {
					var videowidth = 500;
				}

				var tmpID = 'id' + Math.random().toString( 36 ).substr( 2, 16 );
				$( '#linkCommentForm button:first-of-type' ).replaceWith( '<div id="' + tmpID + '">\
			<button type="button" class="recordVideo" id="recordVideo' + tmpID + '">Record a quick video</button>\
			<div id="prev' + tmpID + '"></div>\
			</div>\
			\
			' );

				/* Still in link comments here.  FYI */

				var fileID = $( '#video_tmp_name' ).val();
				console.log( 'tmpName is value is ' + fileID );

				$( '#recordVideo' + tmpID ).click( function() {
					var win = window.open( '/2upRec?id=' + fileID, 'MsgWindow', 'width=' + videowidth + ',height=500' );
					var pollTimer = window.setInterval( function() {
						if ( win.closed !== false ) { // !== is required for compatibility with Opera
							window.clearInterval( pollTimer );
							jQuery( '#' + tmpID ).append( '<input type="hidden" id="video_reply_uploaded" name="video_reply_uploaded" value="' + fileID + '">' );
							jQuery( '#prev' + tmpID ).html( '' );
							jQuery( '#prev' + tmpID ).html( 'Video added.  Click submit to post.<br><video id="' + Math.random().toString( 36 ).substr( 2, 16 ) + '" preload="auto" controls "><source src="/wp-content/themes/soledad-child/temp/' + fileID + '.webm?' + Math.random().toString( 36 ).substr( 2, 16 ) + '=yes" type="video/webm;" /></video>' );
							jQuery( '#recordVideo' + tmpID ).html( 'replace video' );
							jQuery( '#removeVideo' + tmpID ).remove();
							jQuery( '#recordVideo' + tmpID ).after( '<button type="button" class="recordVideo" id="removeVideo' + tmpID + '">Remove Video</button>' );
							console.log( 'video file uploaded' );
							//$('#linkCommentForm #submit').click();
							$( '#removeVideo' + tmpID ).click( function() {
								jQuery( '#video_reply_uploaded' ).remove();
								jQuery( '#removeVideo' + tmpID ).remove();
								jQuery( '#prev' + tmpID ).html( '' );
							} );
						}
					}, 200 );
				} );

			/*
			$('#linkCommentForm .submit').click(function (event) {
				event.preventDefault();
				event.stopPropagation();
				console.log("BUTTON CLICKED");
			});
			*/
	  },

	  } );

	//getCookie("ps_drawer2")
	};//END getLink_comments

	var addLink_comment = function() { /*np++*/
	//log("checking for link between "+getCookie('ps_panel1_ID')+" and "+getCookie('ps_panel3_ID'));

	//$('#linkStatus').html("<div class='spinner'></div>");
	//$('#linkStatus').unbind("click");

	//ctext = $('#linkCommentForm * textarea.comment').text();
	//log(ctext);
		var stop = false;
		if ( typeof $( '#wpgdprc' ).html() !== 'undefined' ) {
			if ( ! $( '#wpgdprc' ).attr( 'checked' ) ) {
				console.log( 'not checked ' );

				$( '.wpgdprc-checkbox' ).addClass( 'comment-error' );
				stop = true;
			} else {
				$( '.wpgdprc-checkbox' ).removeClass( 'comment-error' );
			}
			if ( $( '#comment' ).val() == '' && ! $( '#video_reply_uploaded' ).length ) {
				console.log( 'no content ' );

				$( '.comment-form-comment' ).addClass( 'comment-error' );
				stop = true;
			} else {
				$( '.comment-form-comment' ).removeClass( 'comment-error' );
			}
		}
		if ( stop ) {
			return;
		}

		$( '#linkCommentForm' ).append( '<div id="linkCommentForm_tmptxt"></div>' );

		var tmpfunc = function() {
			//log("change "+$('#linkCommentForm_tmptxt').html());
			$( '#linkCommentForm input.submit' ).attr( 'value', $( '#linkCommentForm_tmptxt' ).html() );
			$( '#reply-title span' ).html( $( '#linkCommentForm_tmptxt' ).html() );
		};

		TweenMax.to( $( '#linkCommentForm_tmptxt' ), 2, { scrambleText: { text: 'LOADING' }, onUpdate: tmpfunc } );

		var form = $( '#linkCommentForm' );

		$.post( {
			type: 'post',
			timeout: 20000,
			url: ajax_object.ajax_url,
			//dataType: "json",
			//data:{'action': 'ps_add_link_comment',"text":ctext},
			data: form.serialize(),
			//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
			error: function( textStatus, textStatus2 ) {
				log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
			},
			success: function( response ) {
				log( 'Drawer Got this from the server (tmpfunc): ' );
				log( response );
				//jQuery( document ).data('html_content_'+post_id,response);
				//$('.drawer'+drawer+' .content .1').html(response);
				//return response;

				//configureDrawerLinks();

				//$('.panel2 .content .comments').html(response);

				sce.set_comment_cookie( response.post_id, response.new_comment_id );

				getLink_comments();
	  },

	  } );

	//getCookie("ps_drawer2")
	};//END addLink_comment

	//$('#mode2').click(function (){refreshLinkToolbar()});
	/*np++*/

	/*
==================================================================
						   ADD A LINK BETWEEN ARTICLES
==================================================================
*/

	var addLink = function() {
		if ( window.loggedin == true ) {
			tmpForm = '<br>\
	<div id="respond" class="comment-respond">\
	<h3 id="reply-title" class="comment-reply-title"><span>ADD A LINK</span> <small><a rel="nofollow" id="cancel-comment-reply-link" href="/wp-admin/admin-ajax.php#respond" style="display:none;">Cancel Reply</a></small></h3>\
	<form action="" method="post" id="linkLinkForm" class="link-form">\
		<input type="hidden" id="action" name="action" value="ps_add_link_link">\
		<input type="hidden" id="action" name="_wpnonce_name" value="">\
		<input type="hidden" id="_wpnonce" name="_wpnonce" value="91ae00ca01">\
		<input type="hidden" id="video_tmp_name" name="video_tmp_name" value="' + Math.random().toString( 36 ).substr( 2, 16 ) + '">\
		<input type="hidden" name="_wp_http_referer" value="/wp-admin/admin-ajax.php">\
		<p class="link-form-link">\
          <button type="button" id="go"></button>\
			<textarea id="link" name="link" cols="45" rows="8" placeholder="Explanation: Please explain why you think there is a link between these 2 articles." aria-required="true"></textarea>\
		</p>\
		<p class="form-submit">\
			<input name="submit" type="submit" id="submit" class="submit" value="Submit"> \
			<input type="hidden" name="link_post_ID" value="1383" id="link_post_ID">\
			<input type="hidden" name="link_parent" id="link_parent" value="0">\
		</p>\
		<input type="hidden" id="_wp_unfiltered_html_link_disabled" name="_wp_unfiltered_html_link" value="7ff761df34">\
	</form>\
	</div>';
		} else {
			tmpForm = '<br><br>You must be logged in to create links.';
		}

		$( '.panel2 .content .comments' ).html( tmpForm );

		focusLink();
		/****************************************************************/

		//setupvid('#linkLinkForm button:first-of-type');

		//setupvid_button('#linkCommentForm button:first-of-type');
		if ( screen.width < 500 ) {
			var videowidth = screen.width;
		} else {
			var videowidth = 500;
		}

		var tmpID = 'id' + Math.random().toString( 36 ).substr( 2, 16 );
		$( '#linkLinkForm button:first-of-type' ).replaceWith( '<div id="' + tmpID + '">\
			<button type="button" class="recordVideo" id="recordVideo' + tmpID + '">Record a quick video</button>\
			<div id="prev' + tmpID + '"></div>\
			</div>\
			\
			' );

		var fileID = $( '#video_tmp_name' ).val();
		console.log( 'tmpName is value is ' + fileID );

		$( '#recordVideo' + tmpID ).click( function() {
			jQuery( '#video_reply_uploaded' ).remove();
			var win = window.open( '/2upRec?id=' + fileID, 'MsgWindow', 'width=' + videowidth + ',height=500' );
			var pollTimer = window.setInterval( function() {
				if ( win.closed !== false ) { // !== is required for compatibility with Opera
					window.clearInterval( pollTimer );

					jQuery( '#' + tmpID ).append( '<input type="hidden" id="video_reply_uploaded" name="video_reply_uploaded" value="' + fileID + '">' );
					jQuery( '#prev' + tmpID ).html( '' );
					jQuery( '#prev' + tmpID ).html( 'Video added.  Click submit to post.<br><video id="' + Math.random().toString( 36 ).substr( 2, 16 ) + '" preload="auto" controls "><source src="/wp-content/themes/soledad-child/temp/' + fileID + '.webm?' + Math.random().toString( 36 ).substr( 2, 16 ) + '=yes" type="video/webm;" /></video>' );
					jQuery( '#recordVideo' + tmpID ).html( 'replace video' );
					jQuery( '#removeVideo' + tmpID ).remove();
					jQuery( '#recordVideo' + tmpID ).after( '<button type="button" class="recordVideo" id="removeVideo' + tmpID + '">Remove Video</button>' );
					console.log( 'video file uploaded' );
					//$('#linkCommentForm #submit').click();
					$( '#removeVideo' + tmpID ).click( function() {
						jQuery( '#video_reply_uploaded' ).remove();
						jQuery( '#video_reply_uploaded' ).remove();
						jQuery( '#video_reply_uploaded' ).remove();
						jQuery( '#removeVideo' + tmpID ).remove();
						jQuery( '#prev' + tmpID ).html( '' );
					} );
				}
			}, 200 );
		} );

		/****************************************************************/

		$( '#linkLinkForm' ).attr( 'action', '' );
		$( '#linkLinkForm * .submit' ).click( function( e ) {
			e.preventDefault();
			//window.loadPageByURL(1,this.href);
			//focusPanel1();
			addLink_comment();
			//log("clicked");

			//<script>(function(){if(window===window.parent){document.getElementById('_wp_unfiltered_html_comment_disabled').name='_wp_unfiltered_html_comment';}})();</script>

			log( 'adding link between ' + getCookie( 'ps_panel1_ID' ) + ' and ' + getCookie( 'ps_panel3_ID' ) + ' (I hope so anyway) ' );

			if ( $( '#linkLinkForm #video_reply_uploaded' ).length ) {
				log( 'possible video' );
		 	var linkVideo = $( '#linkLinkForm #video_reply_uploaded' ).val();
			} else {
				var linkVideo = 'no';
			}

			$.post( {
				type: 'post',
				timeout: 20000,
				url: ajax_object.ajax_url,
				//dataType: "json",
				data: { action: 'ps_add_link', 1: window.panel1_ID, 2: window.panel3_ID, link: $( '#linkLinkForm #link' ).val(), video_tmp_name: $( '#linkLinkForm #video_tmp_name' ).val(), video_reply_uploaded: linkVideo },
				//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
				error: function( textStatus, textStatus2 ) {
					log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
				},
				success: function( response ) {
					log( 'Drawer Got this from the server: ' );
					log( response );
					//jQuery( document ).data('html_content_'+post_id,response);
					//$('.drawer'+drawer+' .content .1').html(response);
					//return response;

					//configureDrawerLinks();
					refreshLinkToolbar();
				},

			} );
		} );

	//$('#linkLinkForm * button').click(function(e) {
		//e.preventDefault();

	//});

	//getCookie("ps_drawer2")
	};//END addLink

	var loadPageByID = function( panel, id, template ) {
		window.panelLoading[ 'panel' + panel ] = true;

		if ( ! id ) {
			dataID = $( '.panel' + panel + ' .content' ).data( 'id' );
			log( 'nope' );
		} else {
			dataID = id;
			log( 'yep' );
		}

		if ( ! template ) {
			template = 'single_3panel';
		//log("nope");
		}

		$( window ).data( 'panel' + panel + '_post', dataID );
		setCookie( 'ps_panel' + panel + '', dataID );

		log( 'loading page by ID' + dataID );
		$( window ).data( 'panel' + panel + '_post', id );

		$.post( {
			type: 'post',
			timeout: 20000,
			url: ajax_object.ajax_url,
			//dataType: "json",
			data: { action: 'ps_get_page_content_full', id: dataID, template: template },
			//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
			error: function( textStatus, textStatus2 ) {
				log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
			},
			success: function( response ) {
			//log('Got this from the server: ');
			//log(response );
			//jQuery( document ).data('html_content_'+post_id,response);
				$( '.panel' + panel + ' .content' ).html( response );
				//return response;
				window.panelLoading[ 'panel' + panel ] = false;

				loadRelatedSidebar( panel, id );
				/*
			$('.panel'+panel+' .content').scrollbar({
				"showArrows": true,
				"scrollx": "advanced",
				"scrolly": "advanced"
			});
			*/
				refreshLinkToolbar();

				$( '.panel' + panel + ' .content * iframe' )
				// check that the pathname component of href doesn't end with "/index.html"
					.filter( function( thisFrame ) {
						log( 'frame found' );
						log( $( thisFrame ).attr( 'width' ) );
						$( thisFrame ).attr( 'width', $( '.panel' + panel + ' .content' ).width() );
						log( $( thisFrame ).attr( 'width' ) );
					} );

				resizeContent();
			},
		} );
	};//END loadPageByID

	var loadRelatedSidebar = function( drawer, id, url ) {
		if ( window.panelLoading[ 'panel' + drawer ] == true ) {
			console.log( 'loadRelatedSidebar: panel ' + drawer + ' is still loading' );
			//alert("panel is still loading");
			return;
		}

		if ( ! id ) {
			if ( ! url ) {
				return;
			}
			$type = 'url';
			id = url;
		} else {
			$type = 'id';
			id = id;
		}

		if ( drawer == '3' ) {
			log( 'drawer is 2, not 3!' );
			drawer = 2;
		}

		$.post( {
			type: 'post',
			timeout: 20000,
			url: ajax_object.ajax_url,
			//dataType: "json",
			data: { action: 'ps_get_related_sidebar_content', postID: id },
			//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
			error: function( textStatus, textStatus2 ) {
				log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
			},
			success: function( response ) {
			//log('Drawer Got this from the server: ');
			//log(response );
			//jQuery( document ).data('html_content_'+post_id,response);
				$( '.drawer' + drawer + ' .content .1' ).html( response ).promise().done( function() {
					log( 'loadRelatedSidebar: HTML -- configuring links for drawer' + drawer );
					//configureDrawerLinks();
					configureDrawer( drawer );
				} );
			//return response;
				//			log('loadRelatedSidebar -- configuring links');
	  },

		} );
	};//END loadRelatedSidebar

	//loadRelatedSidebar('1');

	window.loadPageByURL = function( panel, id ) {
		if ( ! id ) {
			dataID = $( '.panel' + panel + ' .content' ).data( 'id' );
			log( 'nope' );
		} else {
			dataID = id;
			log( 'yep' );
		}

		setCookie( 'ps_panel' + panel + '', dataID );
		log( 'loading page By to panel: ' + panel + ' Url: ' + dataID );
		$( window ).data( 'panel' + panel + '_post', id );

		$( '.panel' + panel + ' .content' ).html( "<div class='loading'>LOADING</div>" );
		TweenMax.to( $( '.panel' + panel + ' .content .loading' ), 1, { scrambleText: 'LOADING' } );

		drawer = panel;

		window.panelLoading[ 'panel' + panel ] = true;

		if ( drawer == '3' ) {
		//log("drawer is 2, not 3!");
			drawer = 2;
		}

		closeDrawer( drawer );

		$.post( {
			type: 'post',
			timeout: 20000,
			url: ajax_object.ajax_url,
			//dataType: "json",
			data: { action: 'ps_get_page_content_full', url: dataID },
			//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
			error: function( textStatus, textStatus2 ) {
				log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
			},
			success: function( response ) {
			//setCookie('ps_panel'+panel+'',dataID);

			//log('Got this from the server: ');
			//log(response );
			//jQuery( document ).data('html_content_'+post_id,response);
				$( '.panel' + panel + ' .content' ).html( response );

				realID = $( '.panel' + panel + ' .content #postID_tag' ).html();

				//setCookie('ps_panel'+panel+'_ID',realID);

				window[ 'panel' + panel + '_ID' ] = realID;

				//log(window.panel1_ID + " -WINDOW-" + window.panel3_ID);

				window.panelLoading[ 'panel' + panel ] = false;

				//log("real id is: "+realID);
				refreshLinkToolbar();
				//	 $('.panel'+panel).scrollbar({});

				panelWidth = $( '.panel' + panel + ' .content' ).width();

				loadRelatedSidebar( panel, '', id );

				$( '.panel' + panel + ' .content * iframe' ).each( function( index ) {
					currentWidth = $( this ).width();
					currentHeight = $( this ).height();

					//log(" "+currentWidth+" "+currentHeight);

					ratio = panelWidth / currentWidth;
					newWidth = currentWidth * ratio;
					newHeight = currentHeight * ratio;

					$( this ).width( newWidth );
					$( this ).height( newHeight );

					log( ratio + ' ' + newWidth + ' ' + newHeight );
				} );
			},
		} );
	};//END window.loadPageByURL

	//For help button
	window.loadContentByURL = function( element_ident, id ) {
		dataID = id;

		log( 'loading page to ' + element_ident + ' Url: ' + dataID );

		$( element_ident ).html( "<div class='loading'>LOADING</div>" );
		TweenMax.to( $( element_ident + ' .loading' ), 1, { scrambleText: 'LOADING' } );

		$.post( {
			type: 'post',
			timeout: 20000,
			url: ajax_object.ajax_url,
			//dataType: "json",
			data: { action: 'ps_get_page_content_full', url: dataID, template: 'content_only' },
			//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
			error: function( textStatus, textStatus2 ) {
				log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
			},
			success: function( response ) {
			//setCookie('ps_elementid'+elementid+'',dataID);

			//log('Got this from the server: ');
			//log(response );
			//jQuery( document ).data('html_content_'+post_id,response);
				$( element_ident ).html( response );

			//realID = $(element_ident).html();

			//setCookie('ps_elementid'+elementid+'_ID',realID);

			//window['elementid'+elementid+'_ID'] = realID;

			//log(window.elementid1_ID + " -WINDOW-" + window.elementid3_ID);

			//log("real id is: "+realID);
			},
		} );
	};//END window.loadContentByURL

	var loadPageToPanel = function( panel, id, template ) {
		log( 'loadPageToPanel' );

		if ( ! id ) {
			dataID = $( '.panel' + panel + ' .content' ).data( 'id' );
		//log("nope");
		} else {
			dataID = id;
		//log("yep");
		}

		if ( ! template ) {
			template = 'single_3panel';
		//log("nope");
		}

		var $urlSwitch = '';

		if ( isNaN( dataID ) ) {
			log( 'id is url' );
			$urlSwitch = 'url';
			window.loadPageByURL( panel, id );
		} else {
			log( 'id is number' );
			$urlSwitch = 'id';
			loadPageByID( panel, id, template );
		}

		log( 'loading ' + $urlSwitch + ' page ' + dataID );

		drawer = panel;

		if ( drawer == '3' ) {
			log( 'drawer is 2, not 3!' );
			drawer = 2;
		}

		closeDrawer( drawer );
	//TweenMax.to($('#resetPage'), 1, {scrambleText:"Reset"});
	};//END loadPageToPanel

	var configureDrawer = function( drawer ) {
		if ( drawer == '2' ) {
		//log("drawer is 2, not 3!");
			var panel = 3;
		} else {
			var panel = 1;
		}

		log( 'configureDrawer: configuring drawer ' + drawer );

		configureDrawerSearch( drawer );

		$( '.drawer' + drawer + ' .content * a' ).filter( function() {
			$( this ).unbind( 'click' );
			$( this ).click( function( e ) {
				e.preventDefault();
				log( 'link clicked' );
				window.loadPageByURL( panel, this.href );
			//focusPanel1();
			//log(this.href);
			} );
		} );
		
		
		log( 'configureDrawer: adding draggables for drawer ' + drawer );
		log('.drawer' + drawer + ' .content * .side-link-container');
		var count = 0;
		$( '.drawer' + drawer + ' .content * .side-link-container' ).filter( function() {
			$( this ).unbind( 'click' );
			log($( this ));
			if ( $( this ).data( 'ui-draggable' ) ) {
				log( 'drag is set, destroying' );
				$( this ).draggable( 'destroy' );
			}

			$( this ).find( 'a' ).click( function( e ) {
				e.preventDefault();
				log( 'link clicked2' );
				window.loadPageByURL( panel, this.href );
				//focusPanel1();
				//log(this.href);
			} );

			//log($(this).attr("id"));

			$( this ).draggable( {
				containment: false,
				revert: true,
				//		helper: "clone",
				helper: function( event ) {
					return $( '<img class="dropme" src="/wp-content/themes/soledad-child/img/ui/drop.svg" alt="Drop Me">' );
				},
				cursor: 'move',
				cursorAt: { top: 50, left: 50 },
				iframeFix: true,
				scroll: false,
				appendTo: '#2up',
				zIndex: 100,
				handle: 'img.dragme',
				start: function( event, ui ) {
					log( event );
					log( ui );
					console.log("test");
					//TweenMax.to($(".dropme"), 2, {rotation:360,ease:Linear.easeNone,repeat:-1});
					TweenMax.to( ui.helper, 2, { rotation: 360, ease: Linear.easeNone, repeat: -1 } );
				},
			} );
		} );

		$( 'div.panel' + panel ).droppable( {
		  drop: function( event, ui ) {
				   // do something with the dock
				   //$(this).doSomething();
				log( 'dropped on panel ' + panel );
				   // do something with the draggable item
				   tmpURL = $( ui.draggable ).find( 'h4' ).find( 'a' ).attr( 'href' );
				   loadPageToPanel( panel, tmpURL );
			   },
		} );
	};//END configureDrawer

	var configureDrawerSearch = function( drawer ) {
		if ( drawer == '2' ) {
		//log("drawer is 2, not 3!");
			var panel = 3;
		} else {
			var panel = 1;
		}

		if ( window.panelLoading[ 'panel' + panel ] == true ) {
			console.log( 'configureDrawerSearch: panel ' + panel + ' is still loading' );
			//alert("panel is still loading");
			return;
		}

		log( 'configureDrawerSearch: configuring search for panel' + panel );
		$( '.drawer' + drawer + ' .content .search .widget.widget_search form' ).unbind();
		if ( ! ( $( '#drawer' + drawer + '_search_output' ).length > 0 ) ) {
			$( "<div id='drawer" + drawer + "_search_output'></div>" ).insertAfter( '.drawer' + drawer + ' .content .widget.widget_search form' );
		}

		$( '.drawer' + drawer + ' .content .search .widget.widget_search form' ).submit( function( e ) {
			e.preventDefault();
			log( 'search ' + drawer + ' clicked' );
			searchString = $( '.drawer' + drawer + ' .content .search .widget.widget_search form input.search-input' ).val();
			$.post( {
				type: 'post',
				timeout: 20000,
				url: ajax_object.ajax_url,
				//dataType: "json",
				data: { action: 'ps_2up_sidebar_search', s: searchString },
				//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
				error: function( textStatus, textStatus2 ) {
					log( 'Got this error from the server: ' + textStatus + ' ' + textStatus2 );
					log( textStatus );
					log( textStatus2 );
				},
				success: function( response ) {
					log( 'Search got this from server: ' );

					log( response.length );
					log( response );

					if ( Array.isArray( response ) ) {
						$( '#drawer' + drawer + '_search_output' ).html( '<ul class="side-newsfeed"></ul>' );

						if ( drawer == '2' ) {
							var side = 'right';
						} else {
							var side = 'left';
						}

						for ( var i = 0; i < response.length; i++ ) {
							var post = response[ i ];

							$( '#drawer' + drawer + '_search_output ul' ).append( '\
				<li class="penci-feed">\
					<div id="drawer' + drawer + '_search_result_' + i + '" class="side-link-container">\
					<div class="side-item">\
						<div class="side-image thumbnail-' + side + '">\
							<a class="penci-image-holder small-fix-size" rel="bookmark" style="background-image: url(\'' + post.thumb + '\');" href="' + post.permalink + '" title="' + post.title + '"></a>\
							\
							\
							\
						</div>\
						<div class="side-item-text">\
								<h4><a href="' + post.permalink + '" rel="bookmark" title="' + post.title + '">' + post.title + '</a></h4>\
						</div>\
					</div>\
					<img class="dragme" src="/wp-content/themes/soledad-child/img/ui/drag' + ( Math.floor( Math.random() * 5 ) + 1 ) + '.svg" alt="Drag Me">\
					</div>\
				</li>\
						' );

						//console.log(post.id);
						}// end for loop

						$( '#drawer' + drawer + '_search_output * a' ).filter( function() {
							$( this ).unbind( 'click' );
							$( this ).click( function( e ) {
								e.preventDefault();
								log( 'link clicked' );
								window.loadPageByURL( panel, this.href );
							//focusPanel1();
							//log(this.href);
							} );
						} );

						$( '#drawer' + drawer + '_search_output * .side-link-container' ).filter( function() {
							$( this ).unbind( 'click' );

							if ( $( this ).data( 'ui-draggable' ) ) {
								log( 'drag is set, destroying' );
								$( this ).draggable( 'destroy' );
							}

							$( this ).find( 'a' ).click( function( e ) {
								e.preventDefault();
								log( 'link clicked2' );
								window.loadPageByURL( panel, this.href );
							//focusPanel1();
							//log(this.href);
							} );

							//log($(this).attr("id"));

							$( this ).draggable( {
								containment: false,
								revert: true,
								//		helper: "clone",
								helper: function( event ) {
									return $( '<img class="dropme" src="/wp-content/themes/soledad-child/img/ui/drop.svg" alt="Drop Me">' );
								},
								cursor: 'move',
								cursorAt: { top: 50, left: 50 },
								iframeFix: true,
								scroll: false,
								appendTo: '#2up',
								zIndex: 100,
								handle: 'img.dragme',
								start: function( event, ui ) {
									log( event );
									log( ui );
									//TweenMax.to($(".dropme"), 2, {rotation:360,ease:Linear.easeNone,repeat:-1});
									TweenMax.to( ui.helper, 2, { rotation: 360, ease: Linear.easeNone, repeat: -1 } );
								},
							} );
						} );
					} else {
						$( '#drawer' + drawer + '_search_output' ).html( response );
					}
				},
			} );
		} );
	};//END configureDrawerSearch

	var configureDrawerLinks = function() {
		configureDrawer( 1 );
		configureDrawer( 2 );

	/*		$('.drawer1 .content * a')
	  // check that the pathname component of href doesn't end with "/index.html"
	  .filter(function() {
		//log($(this).attr('href'));

		$(this).click(function(e) {
		e.preventDefault();
		window.loadPageByURL(1,this.href);
		//focusPanel1();
		//log(this.href);
	  });

	  });
	*/

	/*
	//		 $('.drawer2 .content').scrollbar({});
			$('.drawer2 .content * a')
	  // check that the pathname component of href doesn't end with "/index.html"
	  .filter(function() {
		//log($(this).attr('href'));

		$(this).click(function(e) {
			e.preventDefault();
			//window.loadPageByURL(3,this.href);
			//focusPanel1();
			//log(this.href);
		});

	  });
	*/
	/*
	$( ".drawer2 .content * a" ).filter(function() {
	$(this).unbind( "click" );
	 $(this).click(function(e) {
		e.preventDefault();
		log("link clicked");
		window.loadPageByURL(3,this.href);
		//focusPanel1();
		//log(this.href);
	  });
	});

	$( ".drawer2 .content * .side-link-container" ).filter(function() {

	$(this).unbind( "click" );
	 $(this).find('a').click(function(e) {
		e.preventDefault();
		log("link clicked");
		window.loadPageByURL(1,this.href);
		//focusPanel1();
		//log(this.href);
	  });

		$(this).draggable({
			containment: false,
			revert: true,
			helper: "clone",
			iframeFix: true,
			scroll: false,
			appendTo: "#2up",
			zIndex: 100
		});
	});

	$( "div.panel3" ).droppable({
		  drop: function(event, ui) {
				   // do something with the dock
				   //$(this).doSomething();
					log("dropped on panel 3");
				   // do something with the draggable item
				   tmpURL = $(ui.draggable).find('h4').find('a').attr('href');
				   loadPageToPanel(1,tmpURL);
			   }
	});
	*/
	}; //END configureDrawerLinks

	$.post( {
		type: 'post',
		timeout: 20000,
		url: ajax_object.ajax_url,
		//dataType: "json",
		data: { action: 'ps_get_sidebar_content', name: '2upBottom' },
		//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
		error: function( textStatus, textStatus2 ) {
			log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
		},
		success: function( response ) {
		//log('Got this from the server: ');
		//log(response );
		//jQuery( document ).data('html_content_'+post_id,response);
			$( '.drawer1 .content .2' ).html( response );
			$( '.drawer2 .content .2' ).html( response );
		//return response;
		// $('.drawer1 .content').scrollbar({});

		//setTimeout(function(){
			//configureDrawerLinks();
		//}, (1000));

		 // openDrawer(2);
		//$(".scroll .content").mCustomScrollbar("update");
		// $(".panel").mCustomScrollbar("update");
		},
	} );

	$.post( {/*np++*/
		type: 'post',
		timeout: 20000,
		url: ajax_object.ajax_url,
		//dataType: "json",
		data: { action: 'ps_get_sidebar_content', name: '2upTop' },
		//data:{'action': 'ps_get_external_meta','url': "http://theeverythingcompany.com" },
		error: function( textStatus, textStatus2 ) {
			log( 'Got this error from the server: ' + textStatus + ' ' + textStatus );
		},
		success: function( response ) {
		//log('Got this from the server: ');
		//log(response );
		//jQuery( document ).data('html_content_'+post_id,response);
			$( '.drawer1 .content .search' ).html( response );
			$( '.drawer2 .content .search' ).html( response );
		//return response;
		// $('.drawer1 .content').scrollbar({});

		//setTimeout(function(){
			//configureDrawerLinks();
		//}, (1000));

		 // openDrawer(2);
		//$(".scroll .content").mCustomScrollbar("update");
		// $(".panel").mCustomScrollbar("update");
		},
	} );

	//log("cookie found for panel 1 "+getCookie("ps_panel1"));

	//get the 'index' query parameter
	if ( typeof $_GET.loadlink !== 'undefined' ) {
	//alert($_GET['loadlink']);
	//loadPageByURL(1,$_GET['post1']);
	//loadPageByURL(3,$_GET['post2']);
		setCookie( 'ps_panel1', $_GET.post1 );
		setCookie( 'ps_panel3', $_GET.post2 );
		window.location.href = '/2up';
	} else {
		var $tester = $( '.panel1 .content' ).data( 'id' );

		//log($tester);

		if ( ! getCookie( 'ps_panel1' ) || getCookie( 'ps_panel1' ) == 1236 ) {
			loadPageToPanel( 1, 1236, 'content_only' );
			configureDrawer( 1 );
			//	loadPageToPanel(1,15); //about page
		} else {
			log( 'cookie found for panel 1 ' + getCookie( 'ps_panel1' ) );
			loadPageByURL( 1, getCookie( 'ps_panel1' ) );
		}

		if ( ! getCookie( 'ps_panel3' ) || getCookie( 'ps_panel3' ) == 1236 ) {
			loadPageToPanel( 3, 1236, 'content_only' );
			configureDrawer( 2 );
			//	loadPageToPanel(3,15); //about page
		} else {
			log( 'cookie found for panel 3 ' + getCookie( 'ps_panel1' ) );
			loadPageByURL( 3, getCookie( 'ps_panel3' ) );
		}
	}

	$( '#resetPage' ).click( function() {
		delete_cookie( 'ps_panel1' );
		delete_cookie( 'ps_panel3' );
		delete_cookie( 'ps_panel1_ID' );
		delete_cookie( 'ps_panel3_ID' );
		delete_cookie( 'ps_drawer1' );
		delete_cookie( 'ps_drawer2' );
		log( 'cookies deleted' );
		window.location.href = '/2up';
	//location.reload();
	} );

	log( $( window ).data( 'panel1_post' ) );
	log( $( window ).data( 'panel3_post' ) );
} );
